module.exports = __webpack_public_path__ + "img/vicon2.acb4a7b3.png";